// Enum for render Types for Tasks

export enum renderChoiceEnum {
    Listbox = "Listbox",
    Button = "Button"
}
